import { apiClient } from './apiService';
import {
  CUSTOMERS_EXPORT,
  MEMBERSHIPS_EXPORT,
  ORDERS_EXPORT,
  SALES_SUMMARY_EXPORT
} from './endpoints';

interface ExportResult {
  url: string;
  filename: string;
}

/**
 * Excel exports: the backend writes the file with the same filters and
 * scope as the list, the browser then downloads it with the session token
 * (the file link is protected).
 */
const exportAndDownload = async (
  endpoint: string,
  params: Record<string, unknown>
): Promise<string> => {
  const { data } = await apiClient.post<ExportResult>(endpoint, params);
  await apiClient.downloadFile(data.url, data.filename);
  return data.filename;
};

/** Drops empty values: the list sends none of them either. */
const clean = (params: Record<string, unknown>) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== ''
    )
  );

export const exportService = {
  exportOrders: (params: Record<string, unknown>) =>
    exportAndDownload(ORDERS_EXPORT, clean(params)),
  /** Customers only, whatever role filter the user list has. */
  exportCustomers: (params: Record<string, unknown>) =>
    exportAndDownload(
      CUSTOMERS_EXPORT,
      clean({ ...params, role: undefined, roles: undefined })
    ),
  exportMemberships: (params: Record<string, unknown>) =>
    exportAndDownload(MEMBERSHIPS_EXPORT, clean(params)),
  exportSalesReport: (params: Record<string, unknown>) =>
    exportAndDownload(SALES_SUMMARY_EXPORT, clean(params))
};
